import { createAsyncThunk } from '@reduxjs/toolkit';

import { MosaferatiApiPaths } from 'Feature/Mosaferati/Common/Constant/MosaferatiApiPaths';
import { MosaferatiHttpGetService } from 'Feature/Mosaferati/Common/Services/MosaferatiHttpService';

export const getMosaferatiBimehNamehByShomarehBimehNameh = createAsyncThunk(
  'MosaferatiBimehNamehDetail/GetMosaferatiBimehNamehByShomarehBimehNameh',
  async (query: any) => {
    return await MosaferatiHttpGetService({
      url: `${MosaferatiApiPaths.BimehNameh.GetMosaferatiBimehNamehByShomarehBimehNameh}`,
      params: query,
    });
  }
);
